import { useState, ChangeEvent, useEffect, EventHandler, SyntheticEvent, ChangeEventHandler } from "react";
import { Row, Col, InputGroup, Form, Table, Button, Spinner} from "react-bootstrap";
import { StyledPageSubTitle, StyledPageTitle } from "../../BranchesData/styles";
import { StyledTh } from "../styles";
import StaticFilesHttpService from "../../../../services/http/static-files-http";
import StaticFilesReference from "../../../../constants/staticFilesReference";
import ConfigurationHttpService from "../../../../services/http/configuration-http";
import ConfigurationReference from "../../../../constants/configurationReference";
import { AxiosResponse } from "axios";
import StaticDocument from "../../../../services/entities/static-file-entity";
import Configuration from "../../../../services/entities/configuration-entity";
import Highlighter from "react-highlight-words";
import handleResponseError from "../../../../utils/handleResponseError";

    
    
export default function EngineeringInsurance(){
    const [lastPercentage, setLastPercentage] = useState<number>();
    const [percentage, setPercentage] = useState<number>();

    const [activeByDefault, setActiveByDefault] = useState<boolean>(true);
    const [lastActiveByDefault, setLastActiveByDefault] = useState<boolean>();

    const [loading, setLoading] = useState<boolean>(true);
    const [errorOnLoad, setErrorOnLoad] = useState<boolean>(false);

    const [documentsData, setDocumentsData] = useState<StaticDocument[]>([]);

    const [document, setDocument] = useState<File | null>(null);

    const handlePercentageChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.replace(",", ".");
        setPercentage(value === "" ? 0 : parseFloat(value));
    };

    // eslint-disable-next-line no-undef
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setDocument(e.target.files[0]);
        }
    };

    const showDocument = async (version: number) => {
        const file: File = await StaticFilesHttpService.getFileByReferenceAndVersion(
            StaticFilesReference.EngineeringInsuranceInstructions,
            version
        );

        const url = window.URL.createObjectURL(file);

        window.open(url, "_blank");

        setTimeout(() => URL.revokeObjectURL(url), 10000);
    };

    const fetchData = async () =>{
        try{
            setLoading(true);
            const [
                documentsDataResponse,
                defaultActivedDataResponse,
                percentageDataResponse
            ]: [
                AxiosResponse<StaticDocument[]>,
                AxiosResponse<Configuration>,
                AxiosResponse<Configuration>
            ] = await Promise.all([
                StaticFilesHttpService.getDataStaticFilesByReference(
                    StaticFilesReference.EngineeringInsuranceInstructions
                ),
                ConfigurationHttpService.readOne(
                    ConfigurationReference.EngineeringInsuranceActivatedByDefault
                ),
                ConfigurationHttpService.readOne(
                    ConfigurationReference.EngineeringInsurancePercentage
                )
            ]);


            const activeDefault = defaultActivedDataResponse.data.value === 'A';
            const perc = Number(percentageDataResponse.data.value);

            setDocumentsData(documentsDataResponse.data);

            setLastActiveByDefault(activeDefault);
            setLastPercentage(perc);

            setActiveByDefault(activeDefault);
            setPercentage(perc);

        }catch(e){
            setErrorOnLoad(true);
            console.error(e);
        }finally{
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    const uploadData = async () => {
        try{
            setLoading(true);
            
            const promises: Array<Promise<any>> = [];

            if (activeByDefault && (percentage ?? 0).toString() === '0'){
                handleResponseError(new Error(), 'Impossivel salvar com ativo por padrão e porcentagem 0.');
                return;
            }

            if (percentage !== lastPercentage && percentage !== undefined){
                promises.push(
                    ConfigurationHttpService.update(
                        ConfigurationReference.EngineeringInsurancePercentage,
                        { value: percentage.toString() }
                    )
                );
            }

            if (activeByDefault !== lastActiveByDefault){
                promises.push(
                    ConfigurationHttpService.update(
                        ConfigurationReference.EngineeringInsuranceActivatedByDefault,
                        { value: activeByDefault ? "A" : "N" }
                    )
                );
            }

            if (document != null){
                promises.push(
                    StaticFilesHttpService.uploadStaticFilesReference(
                        StaticFilesReference.EngineeringInsuranceInstructions,
                        document
                    )
                );
            }

            await Promise.all(promises);
            
            setDocument(null);
        }catch(e){
            if(e instanceof Error){ 
                handleResponseError(new Error(), e.message)
            }else{ 
                handleResponseError(new Error(), 'Houve um erro ao salvar dados.')
            }
            setErrorOnLoad(true);
            console.error(e);
        }finally{
            fetchData();
            setLoading(false);
        }
    };

    return (
        <>
            {loading && (
                <Col md={12} className="text-center">
                    <Spinner animation="border" />
                </Col>
            )}
            {!loading && errorOnLoad && (
                <Col md={12} className="text-center">
                    <Form.Label>Erro ao carregar dados.</Form.Label>
                </Col>
            )}
            {!loading && !errorOnLoad && (
                <>
                    <Row>
                        <Col>
                            <StyledPageTitle className="mt-2">Seguro Risco Engenharia</StyledPageTitle>
                        </Col>
                    </Row>
                    <Row className="mt-2 d-flex">
                        <Col xs={3}>
                            <Form.Group className="mr-5">
                                <Form.Label>Porcentagem do valor de seguro</Form.Label>
                                <InputGroup className="mb-3" inputMode="numeric">
                                    <Form.Control
                                        style={{height: '40px'}}
                                        placeholder="Porcentagem do valor de seguro"
                                        aria-label="Porcentagem do valor de seguro"
                                        aria-describedby="insurance-percentage"
                                        type="number"
                                        step="0.01"
                                        value={percentage}
                                        onChange={handlePercentageChange}
                                    />
                                    <InputGroup.Text id="insurance-percentage">%</InputGroup.Text>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col xs={4}>
                            <Form.Label>Seguro pré-selecionado por padrão</Form.Label>
                            <Form.Check
                                style={{height: '40px'}}
                                type="switch"
                                label={(
                                    activeByDefault ?
                                    (
                                        <Form.Label>
                                            Pedidos estão com seguro ao serem criados.
                                        </Form.Label>
                                    ):(
                                        <Form.Label>
                                            Pedidos não estão com seguro ao serem criados.
                                        </Form.Label>
                                    )
                                )}
                                checked={activeByDefault}
                                onChange={
                                    // eslint-disable-next-line no-undef
                                    (e: React.ChangeEvent<HTMLInputElement>) => setActiveByDefault(e.target.checked)
                                }
                            />
                        </Col>
                        <Col xs={4}>
                            <Form.Group controlId="formFileLg" className="mb-3">
                                <Form.Label>
                                    Atualizar documento de apoio vigente
                                </Form.Label>

                                <Form.Control 
                                    className="mb-3"
                                    type="file" 
                                    size="sm"
                                    onChange={handleFileChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={1}>
                            <Button 
                                className="mt-3"
                                onClick={() => uploadData()}
                                disabled={
                                    lastPercentage === percentage
                                    && activeByDefault === lastActiveByDefault
                                    && document === null
                                }
                            >
                                Salvar
                            </Button>
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <StyledPageSubTitle className="mt-2">Documento de apoio vigente</StyledPageSubTitle>
                        <Table bordered hover size="sm" className="text-center">
                            <thead>
                                <tr>
                                    <StyledTh>Criado</StyledTh>
                                    <StyledTh>Versão</StyledTh>
                                    <StyledTh> </StyledTh>
                                </tr>
                            </thead>
                            <tbody>
                                { documentsData &&
                                    documentsData.map((document: StaticDocument, index: number) => { return (
                                        <tr key={document.id ?? index}>
                                            <td>
                                                <Highlighter
                                                    autoEscape
                                                    highlightClassName="highlight-term"
                                                    searchWords={[]}
                                                    textToHighlight={
                                                        document.createdAt ?
                                                        new Date(document.createdAt).toLocaleString() :
                                                        'Sem data de criação'
                                                    }
                                                />
                                            </td>
                                            <td>
                                                <Highlighter
                                                    autoEscape
                                                    highlightClassName="highlight-term"
                                                    searchWords={[]}
                                                    textToHighlight={document.version.toString()}
                                                />
                                            </td>
                                            <td>
                                                <Button
                                                    onClick={
                                                        () => showDocument(document.version)
                                                    }
                                                >
                                                    Visualizar
                                                </Button>
                                            </td>
                                        </tr>
                                    )})
                                }
                            </tbody>
                        </Table>
                    </Row>
                </>
            )}
        </>
    );
}